const { registerServiceWorker } = require("serviceWorker");

import("./App");
registerServiceWorker();
String.prototype.insert = function (what: any, index: any) {
  return index > 0
    ? this.replace(new RegExp(".{" + index + "}"), "$&" + what)
    : what + this;
};
